import { Navigate, Route, Routes } from 'react-router';
import { CreatePlan } from './pages/create-plan';
import { RecommendationType } from './pages/recommendation-type';
import { ShowPlan } from './pages/show-plan';
import { Idp } from '.';

export const IdpRoutes = () => (
  <Routes>
    <Route index element={<Idp />} />
    <Route path="novo" element={<RecommendationType />} />
    <Route path=":id" element={<ShowPlan />} />
    <Route path="novo/:id" element={<CreatePlan />} />
    <Route path="*" element={<Navigate to="/pdi/planos" replace />} />
  </Routes>
);
